import React, { useState } from 'react';
import BoxContainer from '../BoxContainer/BoxContainer';

import { withRouter, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import ErrorMessageInput from '../ErrorMessajeInput/ErrorMessageInput';
import get from 'lodash/get';
import * as APIUtil from '../../utils/service/service_api';
import { setClientStore } from '../../utils/util';
import css from '../../styles/modules/BoxContainer/createaccountfirststep.module.css';
import { BeatLoader } from 'react-spinners';

const CreateAccountVerificationStep = (props) => {
  const history = useHistory();
  const tenantId = get(props, 'tenant._id');
  const { client } = props.history.location.state;
  const { handleSubmit, errors, register } = useForm();
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [border1, setBorder1] = useState(
    `1px solid ${props?.branding?.accentColor}`,
  );

  const onSubmit = (verificationCode) => {
    setLoading(true);
    setError(false);
    const { code } = verificationCode;
    APIUtil.validateSMSCode(tenantId, client?._id, code).then((res) => {
      setLoading(false);
      setError(res['error'] === true);
      if (!res['error']) {
        console.log(client);
        setClientStore(client);
        if (client.email) {
          history.push('/transfer-history');
          setLoading(false);
        } else {
          history.push('/create-account/step-2');
          setLoading(false);
        }
      }
    });
  };

  const reSendCode = () => {
    getCode(tenantId, client._id);
  };

  const getCode = (tenantId, clientid) => {
    APIUtil.getSMSCode(tenantId, clientid).then((res) => {
      return res;
    });
  };

  return (
    <BoxContainer
      showLoginButton={false}
      withDoubleBorder
      withLogButton
      brandLogo
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <h1 className={css.checkYourPhone}>
          Now all you need to do is check your phone.
        </h1>
        <div className={css.subWrapper}>
          <h5 className={css.wrapperLabel}>
            A text message with a 6-digit verification code has been sent to
            your mobile phone.
          </h5>
          <div
            style={{
              boxShadow: `0vw 3px 3px ${props?.branding?.accentColor?.replace(
                /[\d.]+\)$/g,
                '0.25)',
              )}`,
            }}
            className={css.textFieldSub2}
          >
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabelFullWidth}>Code</p>
                <input
                  type="number"
                  placeholder=" "
                  autoComplete="no"
                  name="code"
                  ref={register({
                    required: true,
                    validate: (value) => value.length > 5,
                  })}
                  onKeyUp={() => setError(false)}
                  className={css.textFieldSmall}
                  onFocus={() =>
                    setBorder1(`2px solid ${props?.branding?.accentColor}`)
                  }
                  onBlur={() =>
                    setBorder1(`1px solid ${props?.branding?.accentColor}`)
                  }
                  style={{ border: border1, outline: 'none' }}
                />

                {errors.code && errors.code.type === 'required' && (
                  <ErrorMessageInput>This is required</ErrorMessageInput>
                )}
                {errors.code && errors.code.type === 'validate' && (
                  <ErrorMessageInput>Code must be 6 digits</ErrorMessageInput>
                )}
                {isError && <ErrorMessageInput>Invalid Code</ErrorMessageInput>}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center mt-5">
          <button
            disabled={loading}
            className={css.resendCode}
            style={{ color: props?.branding?.accentColor }}
            onClick={reSendCode}
          >
            Resend Code
          </button>
          <button
            disabled={loading}
            type="submit"
            style={{ backgroundColor: props?.branding?.accentColor }}
            className={css.getStartedBtn}
          >
            {!loading ? 'Submit' : <BeatLoader size={8} color="white" />}
          </button>
        </div>
      </form>
    </BoxContainer>
  );
};
export default withRouter(CreateAccountVerificationStep);

{
}
